import getEnvType from './getEnvTypeApp';

/*
  TODO: Accept redirect route/path and query params as parameters.
*/

const redirectAppURL = ({ appType, redirectURL, path }) => {
  let env = process.env.NODE_ENV;
  if (process.env.GATSBY_STAGING) env = 'staging';
  else if (process.env.GATSBY_PRERELEASE) env = 'prerelease';
  else if (process.env.GATSBY_PRODUCTION) env = 'production';

  const URL = `${getEnvType[appType]?.type[env]}` || `${redirectURL}` || '/';

  if (path) {
    return `${URL}${path}`;
  }

  return URL;
};

export default redirectAppURL;
